import { Redirect } from '@shopify/app-bridge/actions';

/**
 * Top-level redirect for OAuth and reauth flows.
 * In embedded context (Shopify Admin iframe), we MUST use App Bridge Redirect—
 * window.top.location throws SecurityError (cross-origin).
 * Fallback: window.location (redirect our frame only) when not embedded.
 * NOTE: static import — a runtime `require()` is undefined in the Vite
 * browser bundle, which used to make this always take the fallback path.
 */
export function redirectToUrl(url: string, appBridge?: unknown): void {
  if (!url) throw new Error('redirectToUrl called with empty URL');

  try {
    if (appBridge && Redirect?.create && Redirect?.Action?.REMOTE) {
      const redirect = Redirect.create(appBridge as any);
      redirect.dispatch(Redirect.Action.REMOTE, url);
      return;
    }
  } catch {
    // App Bridge Redirect not available
  }

  // Fallback: when in iframe, NEVER use window.top (SecurityError). Use our frame only.
  const inIframe = typeof window !== 'undefined' && window.self !== window.top;
  const target = inIframe ? window : (window.top ?? window);
  target.location.href = url;
}
